import { Info, Li, P, Title, Ul } from '@Components/TermsAndConditions/TermsAndConditions.styled';
import React from 'react';
type Props = {};

export default React.memo(function Terms({}: Props) {
  return (
    <div dir="auto">
      <Title>الشروط والأحكام</Title>
      <P>
        عبر دخولك واستخدامك الموقع فإنك تقر وتوافق، دون إجراء أي تعديل ودون أية قيود أو تبديل، على الأحكام والشروط
        الواردة في هذه (الاتفاقية). أنت تقر وتضمن حقك القانوني للدخول في هذه الاتفاقية واستخدام الموقع وفقاً لجميع
        الشروط والأحكام الواردة فيها.
      </P>
      <P>
        تعود كلمة نحن أو لدينا على يوربارتس وهي من تدير موقع الويب، وكلمة أنت تعود لك كمشتري. يتضمن موقع يوربارتس
        الإلكتروني معلومات حول الخدمات والمنتجات التي توفرها شركة يوربارتس وأي طرف آخر.
      </P>
      <P>
        تسعى شركة يوربارتس قدر الإمكان إلى توفير المعلومات على موقعها بدقة متناهية. إلا أنه قد ترد بعض الأخطاء من حين
        لآخر. ولا تتحمل شركة يوربارتس أي مسؤولية عن أي خطأ في المعلومات التي يتضمنها الموقع.
      </P>
      <P>
        إن أي معلومات ومواد أخرى على الموقع مقدمة بأمانة تامة. وباستخدامك للموقع فإنك توافق وتقر بأنه قد يتم إجراء
        تحديثات عليه، أو تغيير وتعديل الشروط والأحكام أو سياسة خدمة العملاء، أو أي معلومات أخرى، في أي وقت ودون سابق
        إنذار.
      </P>
      <P>
        إن الشروط والأحكام تصبح سارية المفعول بمجرد نشرها على الموقع، ولن يكون لها أي أثر رجعي على أي حجوزات تمت مسبقاً
        من خلاله.
      </P>
      <P>
        يجب عليك قراءة هذه الشروط والأحكام في كل مرة تقوم بزيارة الموقع لضمان أنك على علم بكافة الشروط والأحكام السابقة.
        وبالتالي، فإن استمرارك باستخدام الموقع يعتبر موافقة منك على أي تغيير في الشروط والأحكام.
      </P>
      <P>
        نستخدم معلوماتك لتقديم وتحسين خدمتنا. باستخدام خدمتنا أنت توافق على جمع واستخدام معلوماتك الشخصية وفقاً لهذه
        السياسة. هذه الصفحة تعمل كشروط وأحكام استخدام يوربارتس ما لم يتم ذكر غير ذلك.
      </P>
      <Title>جمع وإسنخدام المعلومات</Title>
      <Info>نحن نجمع ونستخدم معلومات مختلفة متعددة لتقديم وتحسين خدمتنا لك وهي:</Info>
      <Info>معلومات شخصية</Info>
      <Info>
        عند استخدام خدمتنا، قد يُطلب منك أن تُدلي ببعض المعلومات الشخصية للتواصل معك أو تعريفك كعميل. هذه المعلومات قد
        تشمل، ولكن لا تقتصر على:
      </Info>
      <Ul>
        <Li>البريد الإلكتروني</Li>
        <Li>الاسم</Li>
        <Li>رقم الهاتف</Li>
        <Li>العنوان</Li>
        <Li>ملفات تعريف الارتباط واستخدام البيانات</Li>
      </Ul>
      <Title>بيانات الاستخدام</Title>
      <P>
        قد يتم جمع بيانات عن طريق استخدام الخدمة. هذه البيانات قد تشمل ال IP address، نوع المتصفح، إصدار المتصفح، صفحات
        الموقع التي قمت بزيارتها، وقت وتاريخ الزيارة، الوقت الذي مضيته على الصفحة، وبيانات تشخيصية أخرى.
      </P>
      <Title>تتبع وملفات تعريف الارتباط</Title>
      <P>
        نستخدم ملفات الارتباط وتكنولوجيا تتبع مشابهة للتعرف على استخدام خدمتنا والتحفظ على معلومات معينة. ملفات تعريف
        الارتباط هي ملفات صغيرة تحتوي على كم من المعلومات التي ترسل إلى المتصفح الخاص بك وتحفظ على جهازك. يمكنك أن تختار
        رفض جميع الملفات من المتصفح ولكن سيؤثر ذلك على استخدامك بعض من
      </P>
      <Title>نقل المعلومات</Title>
      <Info>
        بياناتك قد يتم نقلها وحفظها على أجهزة كمبيوتر خارج منطقتك أو دولتك وتختلف قوانين حمايتها وفقاً للمكان التابعة
        له.
      </Info>
      <Info>
        إذا قمت باستخدام خدماتنا خارج مصر واخترت أن تقدم معلوماتك لنا، نرجو العلم بأن المعلومات ستنتقل إلى مصر وسيتم
        تخزينها والعمل عليها هناك.
      </Info>
      <Info>موافقتك على سياسة الخصوصية والضغط على تقديم هو دليل على موافقتك التامة في نقل معلوماتك.</Info>
      <Info>
        يوربارتس سيتخذ الإجراءات المنطقية اللازمة للتأكد من أن بياناتك تُعامل بسرية وتوافق سياسة الخصوصية. لن يتم نقل
        بياناتك إلا عبر طرق آمنة تماماً تضمن لك خصوصيتك.
      </Info>
      <Title>المتطلبات القانونية</Title>
      <Info>يوربارتس قد يفشي ببياناتك الشخصية بحسن نية إذا كانت ستخدم الآتي:</Info>
      <Ul>
        <Li>للامتثال لالتزام قانوني.</Li>
        <Li>لحماية حقوق وممتلكات يوربارتسل</Li>
        <Li>لمنع أو البحث في أي خطئ في الاتصال مع خدمتنا</Li>
        <Li>لحماية السلامة الشخصية لمستخدمين الخدمة أو المجتمع</Li>
        <Li>لحماية من المسؤولية القانونية</Li>
      </Ul>
      <Title>أمن البيانات</Title>
      <P>
        أمن بياناتك من أولوياتنا، لكن تذكر أنه لا يوجد طريقة نقل بيانات على الإنترنت أمنة بنسبة 100%. نحن نسعى لاستخدام
        أفضل الطرق لحماية خصوصيتك ولكن لا يوجد ضمانات بنسبة 100%.
      </P>
      <Title>مزودون الخدمة</Title>
      <P>
        قد نقوم بتعيين شركة من طرف ثالث أو أفراد لتسريع وتحسين خدمتنا بالنيابة عنا. هذا الطرف المذكور سيسمح له بالتعرف
        على بياناتك للقيام بمهامه وعمله فقط وغير مصرَّح له الإفشاء ببياناتك كعميل. برجاء العلم بأن أي بيانات بطاقات
        ائتمان لن يتم تخزينها، بيعها، مشاركتها، تأجيرها لأي طرف ثالث كان وهي تبقى سرية بين العميل والبنك التابع له فقط.
      </P>
    </div>
  );
});
